import { render, staticRenderFns } from "./AdaptedPhysicalEducationService.vue?vue&type=template&id=01c0379e&scoped=true"
import script from "./AdaptedPhysicalEducationService.vue?vue&type=script&lang=js"
export * from "./AdaptedPhysicalEducationService.vue?vue&type=script&lang=js"
import style0 from "./AdaptedPhysicalEducationService.vue?vue&type=style&index=0&id=01c0379e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c0379e",
  null
  
)

export default component.exports